export const SN_CMS_PAGE = 'cmsPage'
export const CMS_PAGE_UPDATE_CMS_PAGES = SN_CMS_PAGE + '/UPDATE_CMS_PAGES'
export const CMS_PAGE_ADD_CMS_PAGE = SN_CMS_PAGE + '/ADD_CMS_PAGE'
export const CMS_PAGE_SET_CURRENT = SN_CMS_PAGE + '/SET_CURRENT_CMS_PAGE'
